import { GlassCard, GlassCardContent, GlassCardDescription, GlassCardHeader, GlassCardTitle } from "@/components/ui/glass-card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";
import { useUserTimezone, TIMEZONE_OPTIONS } from "@/hooks/useUserTimezone";

export function ApplicationPreferencesSection() {
  const { timezone, setTimezone, resolvedTimezone, formatDateTime } = useUserTimezone();
  return (
    <GlassCard variant="default" hover={false}>
      <GlassCardHeader>
        <GlassCardTitle className="flex items-center gap-2">
          <Globe className="h-5 w-5" />
          Application Preferences
        </GlassCardTitle>
        <GlassCardDescription>
          Configure basic application settings and preferences
        </GlassCardDescription>
      </GlassCardHeader>
      <GlassCardContent className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="timezone">Timezone</Label>
            <Select value={timezone} onValueChange={setTimezone}>
              <SelectTrigger id="timezone">
                <SelectValue placeholder="Select timezone" />
              </SelectTrigger>
              <SelectContent>
                {TIMEZONE_OPTIONS.map((opt) => (
                  <SelectItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">
              Now: {formatDateTime(new Date(), { timeZoneName: "short" })}
              {timezone === "auto" ? ` · ${resolvedTimezone}` : ""}
            </p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="language">Language</Label>
            <Select defaultValue="en">
              <SelectTrigger>
                <SelectValue placeholder="Select language" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="en">English</SelectItem>
                <SelectItem value="es">Spanish</SelectItem>
                <SelectItem value="fr">French</SelectItem>
                <SelectItem value="de">German</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      </GlassCardContent>
    </GlassCard>
  );
}
